import { useRouter } from 'next/router';

export const useIsPerformanceMonitoringTool = () => {
  const router = useRouter();
  return Boolean(router.query.is_gtmetrix);
};
